import React, { useState } from 'react';
import { renderDropdown, renderInputField } from '../../../common/inputField';
import { useDispatch, useSelector } from 'react-redux';
import { setPatientData } from '../../../actions';
import DateComponent from '../../Registrationform/components/dateComponent';
import dayjs from 'dayjs';

const MensurationalHistory = () => {
  const dispatch = useDispatch();
  const patientData = useSelector((state) => state.clinicalReducer);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(
      setPatientData(`patientHistory.mensurationalHistory.${name}`, value),
    );
  };

  const [selectedDates, setSelectedDates] = useState({
    LMP: patientData.patientHistory.mensurationalHistory.LMP
      ? dayjs(patientData.patientHistory.mensurationalHistory.LMP)
      : null,
  });

  const handleDateChange = (date, dateString, key) => {
    setSelectedDates({
      ...selectedDates,
      [key]: date,
    });
    handleInputChange({
      target: {
        name: key,
        value: dateString,
      },
    });
  };

  return (
    <React.Fragment>
      <p className="lead">MENSTRUAL HISTORY:</p>
      <div className="card_name_container">
        {renderInputField(
          'Cycle Duration Average (days)',
          'cycleDurationAverage',
          patientData.patientHistory.mensurationalHistory.cycleDurationAverage,
          handleInputChange,
        )}
        <div style={{ flex: '1 1' }}>
          <label htmlFor="LMP">Last Menstrual Period (LMP)</label>
          <DateComponent
            id="LMP"
            selectedDate={selectedDates['LMP']}
            handleDateChange={(date, dateString) =>
              handleDateChange(date, dateString, 'LMP')
            }
          />
        </div>
        {renderInputField(
          'Duration of Flow (days)',
          'durationOfFlow',
          patientData.patientHistory.mensurationalHistory.durationOfFlow,
          handleInputChange,
        )}
        {renderInputField(
          'Contraception',
          'contraception',
          patientData.patientHistory.mensurationalHistory.contraception,
          handleInputChange,
        )}
      </div>
      <div className="card_name_container">
        <div style={{ maxWidth: 300 }}>
          {renderDropdown(
            'Dysmenorrhea',
            'dysmenorrohea',
            patientData.patientHistory.mensurationalHistory.dysmenorrohea,
            ['No', 'Yes'],
            handleInputChange,
          )}
        </div>
        <div style={{ maxWidth: 400 }}>
          {patientData.patientHistory.mensurationalHistory.dysmenorrohea ===
            'Yes' && (
            <>
              {renderDropdown(
                'Dysmenorrhea Type',
                'dysmenorroheaType',
                patientData.patientHistory.mensurationalHistory
                  .dysmenorroheaType,
                ['Mild', 'Moderate', 'Severe'],
                handleInputChange,
              )}
            </>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default MensurationalHistory;
